import { createMetaRoute } from '@funtech-int/rival';

import { RouteMeta } from '@/shared/lib/navigation';

export const profilesRoute = createMetaRoute<RouteMeta>();
export const adminFamilyAddRoute = createMetaRoute<RouteMeta>();
